import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import cc from 'classcat';
import PropTypes from 'prop-types';
import { useState } from 'react';
import css from './RatingInput.module.scss';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

var RatingInput = function RatingInput(_ref) {
  var onChange = _ref.onChange,
      value = _ref.value,
      wide = _ref.wide;

  var _useState = useState(Array(5).fill().map(function () {
    return {
      on: false
    };
  })),
      _useState2 = _slicedToArray(_useState, 2),
      stars = _useState2[0],
      setStars = _useState2[1];

  var getStars = function getStars(newCount) {
    var onCount = typeof newCount === 'undefined' ? value : newCount;
    var strs = [];

    for (var i = 0; i < 5; i += 1) {
      strs.push({
        on: i <= onCount - 1
      });
    }

    return strs;
  };

  var mouseOver = function mouseOver(_ref2) {
    var newValue = _ref2.target.value;
    setStars(getStars(Number(newValue)));
  };

  var mouseLeave = function mouseLeave() {
    setStars(getStars());
  };

  var handleChange = function handleChange(_ref3) {
    var newValue = _ref3.target.value;
    setStars(getStars(Number(newValue)));
    onChange(Number(newValue));
  };

  return /*#__PURE__*/_jsx("div", {
    className: cc([css.root, _defineProperty({}, css.wide, wide)]),
    children: stars.map(function (star, idx) {
      var val = idx + 1;
      var id = "star".concat(val);
      var label = "star-label".concat(val);
      return /*#__PURE__*/_jsxs("label", {
        className: css.label,
        htmlFor: id,
        children: [/*#__PURE__*/_jsxs("span", {
          className: "ada-hidden",
          id: label,
          children: ["Rate ", val, " Star", val === 1 ? '' : 's']
        }), /*#__PURE__*/_jsx("input", {
          "aria-labelledby": label,
          checked: val === value,
          className: css.input,
          id: id,
          name: "rating",
          onChange: handleChange,
          onFocus: mouseOver,
          onMouseLeave: mouseLeave,
          onMouseMove: mouseOver,
          onMouseOver: mouseOver,
          required: true,
          type: "radio",
          value: val
        }), /*#__PURE__*/_jsx("div", {
          className: cc([css.star, _defineProperty({}, css.on, star.on)]),
          children: "\u2605"
        })]
      }, id);
    })
  });
};

RatingInput.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  wide: PropTypes.bool
};
export default RatingInput;